import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/ArrowLeft.svg?component
var ArrowLeft_exports = /* @__PURE__ */ __exportAll({
	default: () => ArrowLeft_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M22 12H2m9.3-9.3L2 12l9.3 9.3"
	}, null, -1)])]);
}
var ArrowLeft_default = { render: render$1 };
//#endregion
export { ArrowLeft_exports, ArrowLeft_default as default, render$1 as render };

//# sourceMappingURL=ArrowLeft.svg_component.js.map